<template>
  <router-view />
</template>

<script>
export default {
  name: "ServiceBase",
};
</script>

<style></style>
